import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import ProgressBar from 'react-fine-uploader/progress-bar';
import Parse from 'html-react-parser';
import { Input } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetUserAvatarPreview } from '../../../api/User';
import { getAPIUrl } from '../../../helpers/App';
import { addFlashMessage } from '../../../helpers/FlashMessages';
import { getSetting } from '../../../helpers/Settings';

import ErrorBoundary from '../../ErrorBoundary';

class AdminUserEditAvatar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      submittedFile: null,
      uploading: false,
      uploaded: 0,
      hasThumbnail: !!props.profile.avatar_url,
      error: null,
    };

    this.fileInput = React.createRef();
    this.initUploader();

    this.uploadFile = this.uploadFile.bind(this);
    this.triggerInputFile = this.triggerInputFile.bind(this);
  }

  componentDidMount() {
    const { intl } = this.props;
    this.uploader.on('submitted', (id) => {
      const { loggedInProfile } = this.props;
      this.setState({
        submittedFile: id,
        uploading: true,
        error: null,
      });
      this.uploader.methods.setParams({
        client: loggedInProfile.client.uuid,
      }, id);
    });

    this.uploader.on('progress', (id, name, uploadedBytes, totalBytes) => {
      let uploaded = 0;
      if (uploadedBytes > 0) {
        uploaded = window._.round((uploadedBytes / totalBytes) * 100, 0);
      }
      this.setState({ uploaded });
    });

    this.uploader.on('complete', (id, name, response) => {
      if (!response.success) {
        return;
      }

      this.setState({
        uploading: false,
        uploaded: 0,
      }, () => {
        APIgetUserAvatarPreview(this.uploader.methods.getKey(id)).then((res) => {
          if (res.data && res.data.url) {
            document.getElementById('avatar-preview').setAttribute('src', res.data.url);
            this.setState({
              hasThumbnail: true,
            });
          }
        });
      });
      this.handleChangeAvatar(this.uploader.methods.getKey(id));
    });

    this.uploader.on('error', (id, name, error) => {
      this.setState({
        uploading: false,
        uploaded: 0,
        error,
      });
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({
          defaultMessage: '<strong>Something went wrong.</strong>{br} Please check for error messages.',
        }, { br: '\n' }),
      });
    });
  }

  initUploader() {
    const { intl } = this.props;
    this.uploader = new FineUploaderS3({
      options: {
        debug: process.env.MIX_ENV !== 'production',
        multiple: false,
        request: {
          endpoint: `https://${process.env.MIX_AWS_S3_BUCKET_NAME}.s3.amazonaws.com`,
          accessKey: `${getSetting('upload_key') || process.env.MIX_AWS_ACCESS_KEY_ID}`,
        },
        objectProperties: {
          key: (id) => {
            const { loggedInProfile } = this.props;
            const ext = this.uploader.qq.getExtension(this.uploader.methods.getName(id));
            const uuid = this.uploader.methods.getUuid(id);
            return `${loggedInProfile.client.uuid}/avatars/${uuid}.${ext}`;
          },
        },
        validation: {
          image: {
            minHeight: 400,
            minWidth: 400,
          },
        },
        messages: {
          minHeightImageError: intl.formatMessage({
            defaultMessage: 'Image is too small{br}(minimum size: 400x400 px)',
          }, { br: '<br />' }),
          minwidthImageError: intl.formatMessage({
            defaultMessage: 'Image is too small{br}(minimum size: 400x400 px)',
          }, { br: '<br />' }),
        },
        signature: {
          endpoint: getAPIUrl('/upload'),
          version: 4,
          customHeaders: () => ({
            SPAuth: true,
            Authorization: `Bearer ${Cookies.get('sp_access_token')}`,
          }),
        },
        chunking: {
          enabled: true,
          concurrent: {
            enabled: true,
          },
        },
      },
    });
  }

  uploadFile(e) {
    const { files } = e.target;
    if (files.length > 0) {
      this.uploader.methods.addFiles(files);
    }
  }

  triggerInputFile() {
    const { uploading } = this.state;
    if (!uploading) {
      this.fileInput.current.click();
    }
  }

  handleChangeAvatar(avatarUrl) {
    const { handleChangeAvatar } = this.props;
    handleChangeAvatar(avatarUrl);
  }

  resetImage() {
    const { handleChangeAvatar } = this.props;
    handleChangeAvatar(null);
    this.setState({ hasThumbnail: false });
  }

  render() {
    const {
      submittedFile,
      uploading,
      uploaded,
      hasThumbnail,
      error,
    } = this.state;
    const { intl, profile } = this.props;

    return (
      <ErrorBoundary>
        <div className="profile-avatar-wrapper">
          {/* eslint-disable jsx-a11y/click-events-have-key-events */}
          <div
            className="profile-avatar"
            role="button"
            tabIndex="-1"
          >
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
              className="avatar avatar-200 icon-avatar gray"
              onClick={this.triggerInputFile}
            >
              <img src={profile.avatar_url} alt={profile.name} id="avatar-preview" className="avatar avatar-200" style={{ display: !hasThumbnail ? 'none' : 'unset' }} />
              <i className="fas fa-user" style={{ display: hasThumbnail ? 'none' : 'unset' }} />
              <Input
                type="file"
                name="file"
                accept=".png, .jpg, .jpeg"
                className="upload-file"
                onChange={this.uploadFile}
                innerRef={this.fileInput}
              />
              <div className="profile-avatar-change">
                <i className="far fa-camera" />
                {uploading ? (
                  <span>
                    {intl.formatMessage({ defaultMessage: 'Uploading...' })}
                    <br />
                    {`${uploaded}%`}
                  </span>
                ) : (
                  <span>
                    {intl.formatMessage({ defaultMessage: 'Change' })}
                    <br />
                    {intl.formatMessage({ defaultMessage: 'profile photo' })}
                  </span>
                )}
              </div>
            </div>
            {hasThumbnail && (
              <a
                href="#remove"
                className="profile-avatar-remove"
                onClick={(e) => {
                  e.preventDefault();
                  this.resetImage();
                }}
                title={intl.formatMessage({ defaultMessage: 'Remove image' })}
              >
                <i className="far fa-times" />
              </a>
            )}
            {error && (
              <span style={{ display: 'block' }} className="invalid-feedback">
                {Parse(error)}
              </span>
            )}
          </div>
          {/* eslint-enable jsx-a11y/click-events-have-key-events */}
          <ProgressBar id={submittedFile} uploader={this.uploader} />
        </div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  loggedInProfile: state.Auth.profile,
});

AdminUserEditAvatar.propTypes = {
  intl: PropTypes.object.isRequired,
  loggedInProfile: PropTypes.object.isRequired,
  profile: PropTypes.object,
  handleChangeAvatar: PropTypes.func.isRequired,
};

AdminUserEditAvatar.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(injectIntl(AdminUserEditAvatar));
